<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()"(tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getNewTableData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"[showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Status</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <!--<div class="form-group">-->
      <!--<select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="parentSelected"-->
              <!--(change)="onParentChange($event.target.selectedIndex)">-->
        <!--<option *ngFor="let parent of parents" [value]="parent.id">{{parent.name}}</option>-->
      <!--</select>-->
    <!--</div>-->
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrVal"
               placeholder="Enter value">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrDesc"
               placeholder="Enter Description">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="sequence"
               placeholder="Enter Sequence greater than 0">
      </div>
    </div>
    <div class="form-group font-13">
      <mat-checkbox [(ngModel)]="isChecked">Stop SLA Meter</mat-checkbox>
    </div>
    <div class="form-group font-13">
      <mat-checkbox [(ngModel)]="isCommandRequired">Comment Required</mat-checkbox>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter status Name"
                 [(ngModel)]="statusSelected">
      </div>
  </div>
  <div class="modal-footer pad-8">
     
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  
   

  </div>

  </ng-template>
<notifier-container></notifier-container>

